// services/axiosInstance.js
import axios from "axios";

const baseURL = import.meta.env.VITE_API_BASE_URL;

export const axiosInstance = axios.create({
  baseURL,
});

export const setupAxiosInterceptors = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = store.getState().auth.userAccessToken;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      config.headers["X-API-KEY"] = import.meta.env.VITE_X_API_KEY || "";

      if (!(config.data instanceof FormData)) {
        config.headers["Content-Type"] = "application/json";
      }

      config.headers.Accept = "application/json";
      config.headers["Device-Type"] = 2;

      return config;
    },
    (error) => Promise.reject(error),
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        store.dispatch({ type: "auth/clearToken" });

        // 🔥 VERY IMPORTANT
        localStorage.removeItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af");
        sessionStorage.removeItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af");

        // optional hard redirect
        // window.location.href = "/";
      }
      return Promise.reject(error);
    },
  );
};

export default axiosInstance;
